import React from "react";
import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";

/**
 * Modal wrapper for create/edit forms.
 * The caller provides the form body (`children`) and the submit
 * handler. The header title flips between "Anlegen" and "Bearbeiten"
 * based on the `mode` prop.
 */
export function FormModal({
  open,
  onClose,
  mode = "create", // "create" | "edit"
  entityLabel,
  onSubmit,
  saving,
  children,
  submitTestId = "form-modal-submit",
  cancelTestId = "form-modal-cancel",
  testId = "form-modal",
}) {
  const { t } = useTranslation();
  const heading =
    mode === "edit"
      ? `${t("admin.common.editing")} — ${entityLabel}`
      : `${t("admin.common.creating")} — ${entityLabel}`;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="max-w-lg border-border-subtle bg-surface"
        data-testid={testId}
      >
        <DialogHeader>
          <DialogTitle>{heading}</DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="space-y-4"
        >
          {children}
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={saving}
              data-testid={cancelTestId}
            >
              {t("admin.common.cancel")}
            </Button>
            <Button
              type="submit"
              disabled={saving}
              data-testid={submitTestId}
              className="bg-charcoal text-white hover:bg-charcoal-soft"
            >
              {saving ? t("admin.common.loading") : t("admin.common.save")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
